// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__25L26","requiredAsterisk":"Info_requiredAsterisk__287-3"};